export default __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm@3-e17d33fa75c6a429c9d9bd0400c6b778.png";